(function($) {
	'use strict';
	$.fn.Collection__Sort = function() {
		this.each(function() {

			var $self = $(this);

			// Show our arrows
			$.Body.addClass('manual-sort');

			$self.Collection__Sort_DragAndDrop();
			$self.Collection__Sort_Manual();

		});
		return this;
	};
}(jQuery));
